export default "__VITE_ASSET__15cd11fa__"